import {Component, OnDestroy} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {LocationStrategy} from '@angular/common';
import {AcDialogService, GeneralService, SessionService} from 'ac-infra';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import * as dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
  title = 'armUI';
  endSessionsubscription: Subscription;
  lockSessionsubscription: Subscription;

  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer, private locationStrategy: LocationStrategy,
              private sessionService: SessionService,
              private router: Router,
              private generalService: GeneralService, private dialogRef: MatDialog, private acDialogService: AcDialogService) {
    const baseHref = `../../../..${this.locationStrategy.getBaseHref()}`;

    this.matIconRegistry.addSvgIcon(`add`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseHref}assets/images/actions/add.svg`)
    );

    this.matIconRegistry.addSvgIcon(`edit`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseHref}assets/images/actions/edit.svg`)
    );

    this.matIconRegistry.addSvgIcon(`delete`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseHref}assets/images/actions/delete.svg`)
    );

    this.matIconRegistry.addSvgIcon(`add_disabled`,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseHref}assets/images/actions/add_disabled.svg`)
    );

    this.matIconRegistry.addSvgIcon(`edit_disabled`,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseHref}assets/images/actions/edit_disabled.svg`)
    );

    this.matIconRegistry.addSvgIcon(`delete_disabled`,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseHref}assets/images/actions/delete_disabled.svg`)
    );

    this.matIconRegistry.addSvgIcon(`refresh`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseHref}assets/images/actions/refresh.svg`)
    );

    sessionService.sessionLeasingPath = 'sessionTimeout';
    sessionService.inActivityPath = 'inactivityPeriod';
    sessionService.enrichSessionObject = () => {};

    generalService.doInitValidationsForAcForm = false;

    if (!sessionService.activeSession) {
      sessionService.restoreSession();
    }

    this.endSessionsubscription = this.sessionService.sessionTerminated$.subscribe((event) => {
      this.sessionService.activeSession = undefined;
      this.dialogRef.closeAll();
      this.acDialogService.closeAllDialogs();
      this.router.navigateByUrl('login');
    });

    this.lockSessionsubscription = this.sessionService.sessionLocked$.subscribe((event) => {
      this.dialogRef.closeAll();
      this.acDialogService.closeAllDialogs();
      this.router.navigateByUrl('login');
    });

    dayjs.extend(utc);
  }

  ngOnDestroy(): void {
    this.endSessionsubscription.unsubscribe();
    this.lockSessionsubscription.unsubscribe();
  }
}
